export default async function uninstallServiceWorker() {
  if ('serviceWorker' in navigator) {
    try {
      const registrations = await navigator.serviceWorker.getRegistrations();
      registrations.forEach(registration => {
        if (registration.active?.scriptURL?.endsWith('/sw.js')) {
          registration.unregister();
        }
      });
    } catch (error) {
      console.error('Failed to uninstall service worker:', error);
    }
  }
}
